export default __webpack_public_path__ + "static/media/myPractice_x.fc8f0324.jpg";